import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
//import config from '../../../config.json';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	paper: {
		padding: theme.spacing(2),
		color: theme.palette.text.secondary,
	},
	container: {
		padding: theme.spacing(2),
		color: theme.palette.text.secondary,
	},
	button: {
		margin: theme.spacing(2),
	},
	typography: {
		padding: theme.spacing(2),
	},
	textField: {
		maxWidth: 300,
	},
}));

const Login = (props) => {
	const classes = useStyles();
	const { isLogin, loginUser, actions } = props;
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [ip_username, setUserName] = React.useState(null);
	const [ip_password, setPassword] = React.useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleChangeUserName = (e) => {
		const { name, value } = e.target;
		setUserName(value);
	};

	const handleChangePassword = (e) => {
		const { name, value } = e.target;
		setPassword(value);
	};

	const handleClickLogin = (e) => {
		e.preventDefault();
		if (!(ip_username && ip_password)) {
			return;
		}
		const uDetails = {
			username: ip_username,
			password: ip_password,
			isValid: false,
		};
		actions.checklogin(uDetails);

		// fetch('http://'+config.SERVER_URL+'/api/SampleData/isLoginValid', {
		//     method: 'POST',
		//     headers: {
		//         'Accept': 'application/json',
		//         'Content-Type': 'application/json'
		//     },
		//     body: JSON.stringify(uDetails)
		// })
		// .then(response => response.json())
		//     .then(data => {
		//         if(!data.isValid){
		//             alert("Incorrect user name or password");
		//         }
		//         else {
		//             actions.login(uDetails);
		//             props.handleLoginClick();
		//         }
		//     })
		//     .catch(error => console.error('Unable to login.', error));
	};

	const handleClickLogout = () => {
		actions.reset();
		setUserName('');
		setPassword('');
		props.handleLogoutClick();
	};

	let open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	return (
		<div>
			{!isLogin && (
				<div>
					<IconButton onClick={handleClick}>
						<Avatar src="/broken-image.jpg" />
					</IconButton>
					<Popover
						className={classes.container}
						id={id}
						open={!isLogin ? open : false}
						anchorEl={anchorEl}
						onClose={handleClose}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'center',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
					>
						<Typography className={classes.typography}>
							<TextField
								className={classes.textField}
								required
								id="ip_username"
								name="ip_username"
								label="User Name"
								placeholder="User Name"
								style={{ margin: 8 }}
								fullWidth
								margin="normal"
								InputLabelProps={{
									shrink: true,
								}}
								variant="outlined"
								onChange={handleChangeUserName}
							/>
							<TextField
								className={classes.textField}
								required
								id="ip_password"
								name="ip_password"
								label="Password"
								placeholder="Password"
								style={{ margin: 8 }}
								fullWidth
								margin="normal"
								InputLabelProps={{
									shrink: true,
								}}
								variant="outlined"
								type="password"
								autoComplete="current-password"
								onChange={handleChangePassword}
							/>
							<Box display="flex" justifyContent="flex-end">
								<Button
									variant="contained"
									color="secondary"
									className={classes.button}
									onClick={handleClickLogin}
								>
									Login
								</Button>
							</Box>
						</Typography>
					</Popover>
				</div>
			)}
		</div>
	);
};

Login.propTypes = {};

export default Login;
